var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasswordResetSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 128,
    viewBox: "0 0 90 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "attl0k3v9e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "3mvqbepusc",
    width: "170%",
    height: "170%",
    x: "-35%",
    y: "-25%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.388235294 0 0 0 0 0.549019608 0 0 0 0 0.796078431 0 0 0 0.45 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "c54v75c31d",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "g38674nqva",
    d: "M0 0L90 0 90 96 0 96z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-419 -373) translate(360 304) translate(59 69)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fnnbja1j2b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g38674nqva"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B6CBEA",
    d: "M50.47 60.425c-1.592 0-2.884 1.295-2.884 2.892 0 1.598 1.292 2.893 2.884 2.893 1.593 0 2.884-1.295 2.884-2.893 0-1.597-1.291-2.892-2.884-2.892zm-10.907 0c-1.592 0-2.884 1.295-2.884 2.892 0 1.598 1.292 2.893 2.884 2.893 1.593 0 2.884-1.295 2.884-2.893 0-1.597-1.29-2.892-2.884-2.892zm22.818 0c-1.593 0-2.884 1.295-2.884 2.892 0 1.598 1.291 2.893 2.884 2.893 1.592 0 2.884-1.295 2.884-2.893 0-1.597-1.292-2.892-2.884-2.892zm-34.226 0c-1.593 0-2.884 1.295-2.884 2.892 0 1.598 1.29 2.893 2.884 2.893 1.592 0 2.884-1.295 2.884-2.893 0-1.597-1.292-2.892-2.884-2.892zm59.431 30.702c0 1.352-1.096 2.452-2.444 2.452H4.858c-1.348 0-2.444-1.1-2.444-2.452V37.582c0-1.352 1.096-2.451 2.444-2.451h80.284c1.348 0 2.444 1.1 2.444 2.451v53.545zm-64.72-66.506c0-12.241 9.93-22.2 22.134-22.2 12.205 0 22.134 9.959 22.134 22.2v8.088H22.866v-8.088zm62.276 8.088H69.548v-8.088C69.548 11.045 58.536 0 45 0 31.465 0 20.452 11.045 20.452 24.621v8.088H4.858C2.18 32.71 0 34.895 0 37.582v53.545C0 93.814 2.18 96 4.858 96h80.284C87.82 96 90 93.814 90 91.127V37.582c0-2.687-2.18-4.873-4.858-4.873z",
    mask: "url(#fnnbja1j2b)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-419 -373) translate(360 304) translate(59 69) translate(27 76)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#3mvqbepusc)",
    xlinkHref: "#c54v75c31d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#attl0k3v9e)",
    xlinkHref: "#c54v75c31d"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#5AC692",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M11.839 19.983L19.791 26.919 39.064 6.267",
    transform: "translate(-419 -373) translate(360 304) translate(59 69) translate(27 76)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordResetSuccess);
export default __webpack_public_path__ + "static/media/icon-password-reset-success.f98f2aa8ac47b7ce90c685420aed0479.svg";
export { ForwardRef as ReactComponent };